export interface SuggestionState {

  data: Suggestion[];
  meta: Meta

}

interface Suggestion {
  _id: string
  name: {
    en: string
    ar: string
  }
  slug: string
  icon: string
  image: string
  country: string
  isGlobal: boolean
  outOfStock: boolean
}

interface Meta {
  page: number
  limit: number
  total: number
  totalPages: number
}



export const InitialSuggestionState: SuggestionState = {
  data: [],
  meta: {} as Meta
}